import React from 'react';

import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

interface SucceededAutomationFileButtonProps {
  buttonStyle: ButtonStyle;
  buttonText: string;
  buttonIcon: BenchlingIconName | JSX.Element;
  isStale: boolean;
  locked: boolean;
  handleRefreshVersionedData: () => Promise<void>;
  onClick?: () => void;
  dataTestAttrs?: DataTestAttrs;
}

export default function SucceededAutomationFileButton(
  props: SucceededAutomationFileButtonProps
): JSX.Element {
  return (
    <Button
      buttonStyle={props.buttonStyle}
      size={ButtonSize.MINI}
      fullWidth={true}
      disabled={props.locked}
      text={props.isStale ? `${props.buttonText} - click to sync run` : props.buttonText}
      icon={props.buttonIcon}
      onClick={props.isStale ? props.handleRefreshVersionedData : props.onClick}
      dataTestAttrs={props.dataTestAttrs}
    />
  );
}
